var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	1061: () => (loadSingletonVersion("default", "@angular/core", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	5883: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 845))))))),
	6607: () => (loadSingletonVersion("default", "@angular/common", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	6883: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 8219))))))),
	197: () => (loadSingletonVersion("default", "@angular/core/primitives/di", false, [4,19,2,25], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 2867))))),
	6541: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs-_22bb0").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 5689))))))),
	182: () => (loadSingletonVersion("default", "@angular/cdk/coercion", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_coercion_mjs-_bff61").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	322: () => (loadSingletonVersion("default", "@angular/cdk/bidi", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 3680))))))),
	4622: () => (loadSingletonVersion("default", "@angular/cdk/a11y", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 2102))))))),
	6364: () => (loadSingletonVersion("default", "@angular/cdk/platform", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_platform_mjs-_90951").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 7699))))))),
	7514: () => (loadSingletonVersion("default", "@angular/cdk/private", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_private_mjs-_688b1").then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))))),
	6840: () => (loadSingletonVersion("default", "@angular/cdk/keycodes", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 4879))))))),
	358: () => (loadSingletonVersion("default", "@angular/cdk/dialog", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_dialog_mjs-_76f31").then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 3482))))))),
	1810: () => (loadSingletonVersion("default", "@angular/cdk/overlay", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_overlay_mjs-_40551").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 1570))))))),
	2210: () => (loadSingletonVersion("default", "@angular/cdk/portal", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_portal_mjs-_b9701").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	8222: () => (loadSingletonVersion("default", "@angular/cdk/scrolling", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b01").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 9975))))))),
	5269: () => (loadSingletonVersion("default", "@angular/animations/browser", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_browser_mjs-_2a591").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 655))))))),
	6689: () => (loadSingletonVersion("default", "@angular/common/http", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))))),
	1516: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 436))))))),
	340: () => (loadSingletonVersion("default", "@angular/material/button", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_button_mjs-_52ba0").then(() => (() => (__webpack_require__(/*! @angular/material/button */ 4175))))))),
	1111: () => (loadSingletonVersion("default", "@angular/platform-browser/animations", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a0").then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 3835))))))),
	3276: () => (loadSingletonVersion("default", "@angular/material/core", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_core_mjs-_90eb0").then(() => (() => (__webpack_require__(/*! @angular/material/core */ 4646))))))),
	4771: () => (loadSingletonVersion("default", "@angular/router", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 5072))))))),
	4837: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 9074))))))),
	5148: () => (loadSingletonVersion("default", "@angular/material/dialog", false, [1,19,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_dialog_mjs-_b8750").then(() => (() => (__webpack_require__(/*! @angular/material/dialog */ 2587))))))),
	9561: () => (loadSingletonVersion("default", "@angular/forms", false, [4,19,2,25], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1").then(() => (() => (__webpack_require__(/*! @angular/forms */ 4456)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a590": [
		1061
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca010": [
		1061,
		5883,
		6607,
		6883
	],
	"node_modules_angular_cdk_fesm2022_bidi_mjs-_04d90": [
		1061,
		6607
	],
	"node_modules_angular_cdk_fesm2022_coercion_mjs-_bff60": [
		1061
	],
	"node_modules_angular_cdk_fesm2022_dialog_mjs-_76f30": [
		1061,
		5883,
		6607,
		6883
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40550": [
		1061,
		5883,
		6607,
		6883
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90950": [
		1061,
		6607
	],
	"node_modules_angular_cdk_fesm2022_portal_mjs-_b9700": [
		1061,
		6607
	],
	"node_modules_angular_cdk_fesm2022_private_mjs-_688b0": [
		1061
	],
	"node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b00": [
		1061,
		5883,
		6607,
		6883
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		1061,
		5883,
		6883
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		1061,
		5883
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0": [
		1061,
		5883,
		6883
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		197,
		5883,
		6541,
		6883
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		1061,
		5883,
		6607,
		6883
	],
	"node_modules_angular_material_fesm2022_button_mjs-_52ba1": [
		182,
		322,
		1061,
		4622,
		6364,
		6607,
		7514
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb1": [
		182,
		322,
		1061,
		4622,
		5883,
		6364,
		6607,
		6840,
		6883,
		7514
	],
	"node_modules_angular_material_fesm2022_dialog_mjs-_b8751": [
		182,
		322,
		358,
		1061,
		1810,
		2210,
		4622,
		5883,
		6840,
		6883,
		8222
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a1": [
		1061,
		5269,
		6607
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		1061,
		6607,
		6689
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		1061,
		1516,
		5883,
		6607,
		6883
	],
	"src_bootstrap_ts": [
		340,
		1061,
		1111,
		1516,
		3276,
		4771,
		4837,
		5148,
		5883,
		6607,
		6689,
		6883,
		9561
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		5883
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011": [
		5883,
		6607,
		6883
	],
	"node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91": [
		6607
	],
	"node_modules_angular_cdk_fesm2022_dialog_mjs-_76f31": [
		6607
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40551": [
		6607
	],
	"node_modules_angular_cdk_fesm2022_portal_mjs-_b9701": [
		6607
	],
	"node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b01": [
		6607
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		5883,
		6883
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		6689
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		1516
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a0": [
		5269
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb0": [
		182,
		322,
		4622,
		6364,
		6840,
		7514
	],
	"node_modules_angular_material_fesm2022_dialog_mjs-_b8750": [
		182,
		322,
		358,
		1810,
		2210,
		4622,
		6840,
		8222
	],
	"node_modules_angular_material_fesm2022_button_mjs-_52ba0": [
		182,
		322,
		4622,
		6364,
		7514
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}